module.exports = __webpack_public_path__ + "static/media/title_20.c19c0d75.svg";